import React, { Component } from "react";
import MediaElementVideoComponent from "./MediaElementVideoPlayer";

import XAPIUtils from "../../pages/xapi/xapiutils";

class VideoPlayer extends Component {
    constructor(props) {
        super(props);
    }

    state = {};

    componentDidMount() {
        
    }

    render() {
        return (
                <MediaElementVideoComponent 
                    videoUrl={this.props.url}
                    transcripts={this.props.transcripts}
                    onPlayerEvent={this.onPlayerEvent(this.postMediaData)}
                />
        );
    }

    postMediaData = (eventData, delay)=>{
        console.log(eventData);
        const {item, learningModuleId} = this.props;
        console.log(this.props);
        const result = {
            "extensions": {
                "https://w3id.org/xapi/video/extensions/time": eventData.currentTime,
                "https://w3id.org/xapi/video/extensions/length": eventData.videoLength,
                "https://w3id.org/xapi/video/extensions/progress": delay/1000
            }
        }
        const context = {
            resourceId: item.id,
            learningModuleId,
            "extensions": {
                "https://w3id.org/xapi/video/extensions/length": eventData.videoLength
            }
        }
        const j = {"result":result,"context":context}

        item.typeId = -5;

        item["ext"] = j;

        XAPIUtils.track(item);
    }

    onPlayerEvent(cb, delay= 1000) {
        let shouldWait = false;
        let waitingArgs = null;
        
        const timeOutFunc = ()=>{
            
            if(waitingArgs === null){
                shouldWait = false;
            }else{
                cb(waitingArgs, delay)
                waitingArgs = null;
                setTimeout(timeOutFunc,delay);
            }
            
        }
        
        return (eventData)=>{
            // console.log("onPlayerEvent>>> "+JSON.stringify(eventData));
            if(isNaN(eventData.videoLength)) return;
            if(eventData.event !== "timeupdate" && eventData.event !== "ended") return;
            if (shouldWait){

                if(waitingArgs?.event === "ended") return;

                waitingArgs = eventData;
                return;
            } 
    
            cb(eventData, delay);
            shouldWait = true;
    
            setTimeout(timeOutFunc,delay);
        }
    }

}

export default VideoPlayer;